import React from "react";
import { Typography, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import styles from "./ApplicationFormModal.module.scss";

/**
 * Left panel: Upload & Autofill – upload Green Application Form for OCR.
 */
export default function OCRUploadPanel({ onUpload, disabled }) {
  const inputRef = React.useRef(null);

  const handleClick = () => {
    if (disabled) return;
    inputRef.current?.click();
  };

  const handleChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onUpload(file);
      e.target.value = "";
    }
  };

  return (
    <div className={styles.panel}>
      <Typography className={styles.panelTitle}>Upload & Autofill</Typography>
      <Typography className={styles.panelDescription}>
        Upload the student's Green Application Form and the system will automatically extract the details and fill the form.
      </Typography>
      <Typography className={styles.panelSubtext}>Fill application forms twice as fast.</Typography>
      <input
        ref={inputRef}
        type="file"
        accept=".pdf,.jpg,.jpeg,.png"
        onChange={handleChange}
        style={{ display: "none" }}
      />
      <Button
        variant="contained"
        className={styles.panelButton}
        startIcon={<CloudUploadIcon />}
        onClick={handleClick}
        disabled={disabled}
      >
        Upload Form
      </Button>
    </div>
  );
}
